/* src/app/views/admin/visits/visits.component.css */
input#document_upload {
  display: none;
}
::ng-deep p-paginator svg {
  transform: rotate(180deg);
}
/*# sourceMappingURL=visits.component.css.map */
